import Dropdown from "../../bootstrap/dropdown";

// Top Navigation

const desktopNavLinks = document.querySelectorAll('#desktop-nav .navigation-link');
const megaMenus = document.querySelectorAll('.mega-menu');

const closeAllMenus = () => {
    megaMenus.forEach(menu => menu.classList.remove('show'));
    desktopNavLinks.forEach(link => link.classList.remove('active'));
};

const toggleMenu = (link) => {
    const key = link.dataset.nav;
    const panel = document.querySelector(`[data-panel="${key}"]`);
    const isActivePanel = document.querySelectorAll('.mega-menu.show');

    if (!panel) {
        closeAllMenus();
        link.classList.add('active');
        return;
    }

    const isOpen = panel.classList.contains('show');

    closeAllMenus();

    if (!isOpen) {
        if (isActivePanel.length > 0) {
            setTimeout(() => {
                panel.classList.add('show');
                link.classList.add('active');

            }, 200)
        } else {
            panel.classList.add('show');
            link.classList.add('active');
        }
    }
};
const desktopNavigation = () => {
    desktopNavLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            toggleMenu(link);
        });
    });
};

// Navigation Mega Menu

const courseButtons = document.querySelectorAll('.course-btn');
const courseContents = document.querySelectorAll('.course-content');
const removeActiveButtons = () => {
    courseButtons.forEach(button => {
        button.classList.remove('active');
    })
}

const showActiveContent = (key) => {
    courseContents.forEach(content => {
        content.classList.remove('show');
        if (content.dataset.content == key) {
            content.classList.add('show');
        }
    });
}

const coursesNavigation = () => {
    courseButtons.forEach(button => {
        button.addEventListener('mouseenter', e => {
            e.preventDefault();
            removeActiveButtons();
            const data = button.dataset.course;
            showActiveContent(data);
            button.classList.add('active');
        });
    })

}

// Mobile Nav
// Hamburger Toggler
const mobileNavBackdrop = document.querySelector('.backdrop');
const mobileNavOpenButton = document.querySelector('#mobile-nav-btn');
const mobileNavCloseButton = document.querySelector('#mobile-nav-close');
const mobileNav = document.querySelector('#mobile-nav');
const toggleMobileNav = () => {
    mobileNavOpenButton.addEventListener('click', e => {
        document.querySelector('#mobile-nav').classList.add('show');
    })

    mobileNavCloseButton.addEventListener('click', e => {
        document.querySelector('#mobile-nav').classList.remove('show');
    })

    mobileNavBackdrop.addEventListener('click', e => {
        document.querySelector('#mobile-nav').classList.remove('show');
    })
}

// Mobile Navigation
const mobileNavLinks = document.querySelectorAll('.mobile-nav-link a');
const mobileSubnavLinks = document.querySelectorAll('.mobile-subnav-link a');
const mobileNavigation = () => {
    mobileNavLinks.forEach(link => {
        link.addEventListener('click', e => {
            const parentLi = link.parentElement;
            const subnav = parentLi.querySelector(':scope > ul.mobile-subnav-links');

            if (!subnav) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            link.classList.toggle('active');
            subnav.classList.toggle('show');

        })
    });

    mobileSubnavLinks.forEach(link => {
        link.addEventListener('click', e => {
            const parentLi = link.parentElement;
            const subnav = parentLi.querySelector(':scope > ul.mobile-subnav-child-links');
            if (!subnav) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            link.classList.toggle('active');
            subnav.classList.toggle('show');
        })
    })
}

const windowDetector = () => {
    document.addEventListener('click', (e) => {
        
        const clickedInsideNav = e.target.closest('#desktop-nav');
        const clickedInsideMenu = e.target.closest('.mega-menu');
        const clickedOnSearchBtn = e.target.closest('#search-button');
        
        if (!clickedInsideNav && !clickedInsideMenu && clickedOnSearchBtn) {
            closeAllMenus();
        }

    });
}

// Country Selector
const initCountrySelectors = () => {
    const countrySelectors = document.querySelectorAll('.book-now.region');

    countrySelectors.forEach((selector) => {
        selector.addEventListener('click', (e) => {
            const dropdownContainer = selector.querySelector('.dropdown-container');
            if (!dropdownContainer.style.display || dropdownContainer.style.display === 'none') {
                dropdownContainer.style.display = 'block';
            } else {
                dropdownContainer.style.display = 'none';
            }
        });
    });
};

// Window Resizer
let windowWidth = window.innerWidth;
const windowResizer = () => {
    window.addEventListener('resize', () => {
        if (windowWidth != window.innerWidth) {
            document.querySelector('#mobile-nav').classList.remove('show');
            closeAllMenus();
            windowWidth = window.innerWidth;
        }
    });
};


window.addEventListener("load", () => {
    windowDetector();
    desktopNavigation();
    coursesNavigation();
    toggleMobileNav();
    mobileNavigation();
    initCountrySelectors();
    windowResizer();
});